export default __webpack_public_path__ + "70981c19898807b8f60414c60168eabd.png";